import type { ReactElement } from 'react';
import { ProductCarouselSchema } from '@amplience/content-types';
import { ProductCarousel } from '@storefront/lib-global/globalComponents/carousel/productCarousel/ProductCarousel';

export const PLPAmplienceComponents: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [k: string]: (props: any) => ReactElement | null;
} = {
  [ProductCarouselSchema.$id]: ProductCarousel,
};
